<template>
  <div>
    <page-title heading="Rekam Medis" :breadcrumb="[
        {
          label: 'Rekam Medis'
        },
        {
          label: 'Riwayat',
          active: true
        }
      ]" defaultSlotCol="7" rightSlot>
      <template v-slot:defaultSlot>
        <b-col sm="8">
          <b-row>
            <b-col sm="12">
              <h5 class="display-4 mt-1 mb-2 font-weight-bold text-left">Riwayat Rekam Medis</h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="4">
              <p class="text-uppercase mb-2 text-left">Nama Pasien</p>
            </b-col>
            <b-col sm="1">:</b-col>
            <b-col sm="6">
              <p class="text-uppercase text-left mb-2">{{ pasien.nama }}</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="4">
              <p class="text-uppercase mb-2 text-left">Nomor Rekam Medis</p>
            </b-col>
            <b-col sm="1">:</b-col>
            <b-col sm="6">
              <p class="text-uppercase text-left mb-2">{{ pasien.nomor_rekam_medis }}</p>
            </b-col>
          </b-row>
        </b-col>
      </template>
      <template v-slot:rightSlot>
        <b-col sm="4" class="d-flex align-items-center justify-content-around">
          <b-button variant="primary" v-show="showBackButton()" class="text-uppercase" @click="kembali()">kembali</b-button>
          <!-- <b-button variant="info" class="text-uppercase" @click="
              rekamMedis({
               pasien_id: pasien.id,
               klinik_id: pasien.klinik_id
               })">tulis rekam medis</b-button> -->
        </b-col>
      </template>
    </page-title>
    <div class="container-fluid">
      <div class="card card-box ">
        <div class="card-body p-4">
          <b-row style="height:700px;">
            <b-col sm="6">
              <LeftColumn class="rrm-content" />
            </b-col>
            <b-col sm="6">
              <RightColumn class="rrm-content" />
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import axios from "axios";
    import {
        library
    } from "@fortawesome/fontawesome-svg-core";
    import {
        faArrowRight,
        faArrowUp,
        faTrashAlt,
        faSearch,
        faPencilAlt,
        faCopy
    } from "@fortawesome/free-solid-svg-icons";
    // import { Datetime } from "vue-datetime";
    import "vue-datetime/dist/vue-datetime.css";
    import startCase from "lodash/startCase";
    import upperCase from "lodash/upperCase";
    import moment from "moment";
    moment.locale('id');


  library.add(faArrowRight, faArrowUp, faTrashAlt, faSearch, faPencilAlt, faCopy);
  export default {
    props: {
      pasien_id: [Number, String],
      rekam_medis_id: {
        required: false,
        type: Number,
        default: () => null,
      }
    },
    data() {
      return {
        pasien: "",
        klinik_id: "",
      }
    },
    components: {
      LeftColumn: () => import("./RiwayatRekamMedis/LeftColumn.vue"),
      RightColumn: () => import("./RiwayatRekamMedis/RightColumn.vue")
    },
    beforeRouteLeave(to, from, next) {
      if (localStorage.getItem('IDLE') != 1) {
        localStorage.removeItem('rekam_medis');
        next();
      } else {
        next();
      }
    },
    methods: {
      showBackButton(){
        if (localStorage.getItem('ALLOW_BACK_MR_TAB') == 1) {
          return true;
        }
        return false;
      },
      kembali() {
        let url = localStorage.getItem('rekam_medis')
        this.$router.push({
          path: url
        });
      },
      async fetchPasien() {
        let res = await axios.get(`${this.url_api}/pasien/${this.pasien_id}`);
        if (res.data.status == false || res.data.data_rm == false) {
          this.$swal({
            type: "error",
            title: startCase("Gagal"),
            text: startCase(`Pasien ${res.data.data.nama} belum memiliki rekam medis!`)
          }).then(res => {
            if (res.value) {
              // http://localhost:8080/rekam-medis/746/1689
              this.$router.go(-1);
            }
          });
        }
        this.pasien = res.data.data;
      },
      rekamMedis({
        pasien_id,
        klinik_id
      }) {
        this.$router.push(`/rekam-medis/${klinik_id}/${pasien_id}`);
      },
    },
    mounted() {
      Promise.all([
        this.cekPaketNolock(),
        this.fetchPasien()
      ]);

      if(this.rekam_medis_id) {
        this.$root.$emit('rerender', this.rekam_medis_id)
      }
    }
  };
</script>

<style lang="scss" scoped>
  .rrm-content {
    overflow-x: hidden;
    overflow-y: auto;
    max-height: 700px;
    margin-top: 20px;
  }

  @media (max-width: 300px) {
    .rrm-content {
      margin-top: 20px;
      max-height: 200px;
    }
  }
</style>
